"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DataTable;

var _react = _interopRequireDefault(require("react"));

var _table = require("baseui/table");

var _pagination = require("baseui/pagination");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function DataTable(props) {
  var _React$useState = _react["default"].useState(1),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentPage = _React$useState2[0],
      setCurrentPage = _React$useState2[1];

  var data = props.data;
  if (!data || data.length === 0) return null;
  var numPages = Math.floor(data.length / 10);
  var columns = Object.keys(data[0].properties).map(function (each) {
    return (0, _utils.humanize)(each);
  });
  var rows = data.slice(currentPage * 10, currentPage * 10 + 10).map(function (feature) {
    return Object.keys(feature.properties).map(function (e) {
      return feature.properties[e];
    });
  });
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_pagination.Pagination, {
    numPages: numPages,
    currentPage: currentPage,
    onPageChange: function onPageChange(_ref) {
      var nextPage = _ref.nextPage;
      setCurrentPage(Math.min(Math.max(nextPage, 1), numPages));
    }
  }), _react["default"].createElement(_table.Table, {
    columns: columns,
    data: rows
  }), _react["default"].createElement(_pagination.Pagination, {
    numPages: numPages,
    currentPage: currentPage,
    onPageChange: function onPageChange(_ref2) {
      var nextPage = _ref2.nextPage;
      setCurrentPage(Math.min(Math.max(nextPage, 1), numPages));
    }
  }));
}